import axios from "axios";
import store from "./store";
// import router from "./router";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  withCredentials: true,
  timeout: 20000, // set the default timeout for requests to 5 seconds
});

// Axios 401 error handling
// instance.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response && error.response.status === 401) {
//       // If a 401 error occurs, open the login modal and redirect to home
//       store.dispatch('auth/logout');
//       store.dispatch('modals/openModal', { modalName: 'login' });

//       router.push('/home'); // Redirect to home page
//     }
//     return Promise.reject(error);
//   }
// );

instance.interceptors.request.use(
  function (config) {
    // Take currency code from Vuex store
    const currency = store.getters["currency/currentCurrency"];

    if (currency) {
      const method = (config.method || "get").toLowerCase();

      if (method === "get") {
        config.params = { ...(config.params || {}), currency };
      } else {
        // Handle FormData separately
        const contentType = (config.headers && (config.headers["Content-Type"] || config.headers["content-type"])) || "";
        if (config.data instanceof FormData || String(contentType).includes("multipart/form-data")) {
          if (config.data instanceof FormData) {
            if (!config.data.has("currency")) config.data.append("currency", currency);
          } else {
            // If not actual FormData instance, fallback to params
            config.params = { ...(config.params || {}), currency };
          }
        } else {
          config.data = { ...(config.data || {}), currency };
        }
      }
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default instance;
